import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/app/(auth)/login/page.tsx");
